module.exports = __webpack_public_path__ + "img/app-tiktok.7b15f37d.webp";